import { render, staticRenderFns } from "./PopupButton.vue?vue&type=template&id=981e3712&scoped=true"
import script from "./PopupButton.vue?vue&type=script&lang=js"
export * from "./PopupButton.vue?vue&type=script&lang=js"
import style0 from "./PopupButton.vue?vue&type=style&index=0&id=981e3712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e3712",
  null
  
)

export default component.exports